import update from 'react-addons-update'
import { handleActions } from 'redux-actions'

export default function buildDialogReducer (dialogName) {
  return handleActions(
    {
      [`OPEN_${dialogName}_DIALOG`]: (state, action) => {
        return {
          ...state,
          show: true,
          ...action.payload
        }
      },
      [`CLOSE_${dialogName}_DIALOG`]: (state, action) => {
        return {
          ...state,
          show: false,
          edits: {}
        }
      },
      [`CHANGE_${dialogName}_DIALOG_VALUE`]: (state, action) => {
        let updateObj = {
          edits: {
            [action.payload.fieldName]: { $set: action.payload.value }
          }
        }
        let newState = update(state, updateObj)
        return newState
      },
      [`SAVE_${dialogName}_DIALOG_SUCCESS`]: (state, action) => {
        return {
          show: false,
          edits: {},
          visitId: null
        }
      }
    },
    {
      show: false,
      edits: {}
    }
  )
}



// WEBPACK FOOTER //
// ./src/redux/reducers/buildDialogReducer.js